import Swiper from "swiper";
import { initIntersectionObserver } from "@plugins";

const parameters = document.querySelectorAll(".js-card-parameters");

if (window.mobileMedia && parameters) {
    for (const block of parameters) {
        initIntersectionObserver(block, initParametersSlider);
    }
}

function initParametersSlider(swiper) {
    new Swiper(swiper, {
        slidesPerView: "auto",
        spaceBetween: 8,
        centerSlidesBounds: true,
        watchOverflow: true,
    });
}
